
import { computed, defineComponent, PropType, ref } from 'vue'
import { REPORT_VIEW } from '@/shared/constants'
import { ReportViewType } from '@/shared/types'

export default defineComponent({
  name: 'ChoiceReportCategory',

  props: {
    reportsType: String as PropType<ReportViewType>,
  },

  setup(props, { emit }) {
    const plaqueReports = ref(0)

    const handleGetReports = (value: ReportViewType) => {
      emit('change-category', value)
    }

    const plaqueIndexBtnClasses = computed(() => {
      return [
        'report-category__button',
        {
          'report-category__button--active':
            props.reportsType === REPORT_VIEW.plaqueIndex,
        },
      ]
    })

    const periodontalBtnClasses = computed(() => {
      return [
        'report-category__button',
        {
          'report-category__button--active':
            props.reportsType === REPORT_VIEW.periodontal,
        },
      ]
    })

    const brushBtnClasses = computed(() => {
      return [
        'report-category__button',
        {
          'report-category__button--active':
            props.reportsType === REPORT_VIEW.brushMap,
        },
      ]
    })

    const riskMapBtnClasses = computed(() => {
      return [
        'report-category__button',
        {
          'report-category__button--active':
            props.reportsType === REPORT_VIEW.riskMap,
        },
      ]
    })

    return {
      REPORT_VIEW,
      handleGetReports,
      plaqueIndexBtnClasses,
      periodontalBtnClasses,
      brushBtnClasses,
      riskMapBtnClasses,
      plaqueReports,
    }
  },
})
